import { Button } from "@prismicio/editor-ui"
import { useSuspenseQuery } from "@tanstack/react-query"

import { useAiABMLandingPagesFlag } from "../../app/integrations/AmplitudeExperiments"
import { abmLandingPagesApiClient } from "../../app/services/aiLandingPage"
import { type Release } from "../../app/services/release"

interface ReleaseDownloadCSVButtonProps {
  release: Release
}

export function ReleaseDownloadCSVButton(props: ReleaseDownloadCSVButtonProps) {
  const { release } = props

  const { disabled } = useDownloadCSVButton(release)

  const downloadLink = abmLandingPagesApiClient.buildCsvDownloadLink({
    releaseId: release.id,
  })

  return disabled ? (
    <></>
  ) : (
    <Button
      size="large"
      startIcon="cloud"
      color="grey"
      disabled={disabled}
      asChild
    >
      <a href={downloadLink} target="_blank" rel="noreferrer">
        Download CSV
      </a>
    </Button>
  )
}

function useDownloadCSVButton(release: Release) {
  const isABMEnabled = useAiABMLandingPagesFlag({ active: true }) === "on"
  const { data: enabled } = useSuspenseQuery({
    queryKey: ["csvExists", { releaseId: release.id }],
    queryFn: async () => {
      if (!isABMEnabled) return false
      return await abmLandingPagesApiClient.checkCsvExists({
        releaseId: release.id,
      })
    },
  })

  return {
    disabled: !enabled,
  }
}
